import React, { useMemo } from "react";
import { copyToClipboard } from "../../utils";

function tryParseJsonString(s) {
  if (typeof s !== "string") return null;
  const t = s.trim();
  if (!t) return null;
  if (!(t.startsWith("{") || t.startsWith("["))) return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}

export default function LogDetailsPanel({ styles, selected, setSelected }) {
  const safeSelected = selected || null;
  const audit = safeSelected?._audit || { action: "", hostCodeMasked: "" };

  const jsonObj = useMemo(() => {
    if (!safeSelected) return null;

    // UI helper fields weg
    const { _msg, _time, _lvl, _audit, ...rest } = safeSelected;

    // message ist JSON-String? -> parse für schönes Preview (keine Backslashes)
    if (typeof rest.message === "string") {
      const parsed = tryParseJsonString(rest.message);
      if (parsed) rest.message = parsed;
    }

    return rest;
  }, [safeSelected]);

  const jsonPretty = useMemo(() => {
    if (!jsonObj) return "";
    return JSON.stringify(jsonObj, null, 2);
  }, [jsonObj]);

  if (!safeSelected) return null;

  const pill = (text) => ({
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    lineHeight: 1,
    opacity: 0.9,
    border: "1px solid rgba(15,23,42,0.11)",
    background: "rgba(15,23,42,0.044)",
    maxWidth: 240,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  });

  return (
    <div style={styles.side}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <h3 style={{ ...styles.sideTitle, margin: 0, lineHeight: 1.1 }}>Log-Details</h3>
            <span style={{ fontSize: 12, opacity: 0.75, whiteSpace: "nowrap" }}>{safeSelected._time}</span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={styles.badge(safeSelected._lvl)}>{safeSelected._lvl}</span>
            {audit.action ? <span style={pill(audit.action)}>Aktion: {audit.action}</span> : null}
            {audit.hostCodeMasked ? <span style={pill(audit.hostCodeMasked)}>Host: {audit.hostCodeMasked}</span> : null}
          </div>
        </div>

        <button style={styles.smallBtn} onClick={() => setSelected(null)} title="Schließen">
          ✕
        </button>
      </div>

      {/* JSON Preview */}
      <div style={{ marginTop: 12 }}>
        <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>JSON</div>

        <pre
          className="scrollbar-dark"
          style={{
            ...styles.pre,
            margin: 0,
            whiteSpace: "pre",
            overflow: "auto", // horizontal + vertical scrollbar
            fontSize: 12,
            lineHeight: 1.4,
            maxHeight: 340, // optional, macht’s “dashboard-like”
          }}
        >
          {jsonPretty}
        </pre>
      </div>

      {/* Actions */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
        <button style={styles.button(true)} onClick={() => copyToClipboard(jsonPretty)} title="Formatiertes JSON kopieren">
          JSON kopieren
        </button>
      </div>
    </div>
  );
}
